export default {"src":"/_next/static/media/close-icon.ed95ea8a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};